// src/services/manifestacionInteresService.js
import axios from 'axios';
import config from '../../config'; // Ajusta si la ruta cambia

const baseUrl = config.baseUrl || '';
const endpoint = '/api/documentos-mi/upload';
const API_URL = `${baseUrl}${endpoint}`;

/**
 * Sube archivos de manifestación de interés al servidor.
 * @param {FormData} formData
 */
export const subirManifestacionInteres = async (formData) => {
  return await axios.post(API_URL, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
